import { gql } from '@apollo/client';

// Multimodal content interfaces
export interface MediaContentMetadata {
  _id: string;
  name: string;
  mimetype: string;
  size: number;
  description?: string;
  agent_id: string;
  owner_id: string;
}

export interface MediaContent {
  type: 'image' | 'video' | 'audio' | 'document';
  url: string;
  metadata: MediaContentMetadata;
}

export interface MemoryEntryContent {
  text?: string;
  media?: MediaContent[];
}

export interface MemoryMetadata {
  tags: string[];
  source: string;
  source_id: string;
  source_name: string;
  source_type: string;
  source_url: string;
}

export interface MemoryEntry {
  _id: string;
  agent_id: string;
  content: MemoryEntryContent;
  created_at: string;
  updated_at: string;
  embedding: number[];
  metadata: MemoryMetadata;
  score?: number; // For search results
}

export const CREATE_MEMORY_ENTRIES = gql`
  mutation CreateMemoryEntries($data: CreateMemoryEntriesInputType!) {
    create_memory_entries(data: $data) {
      hasError
      message
      data {
        _id
        agent_id
        content {
          text
          media {
            type
            url
            metadata {
              _id
              name
              mimetype
              size
              description
              agent_id
              owner_id
            }
          }
        }
        created_at
        updated_at
        embedding
        metadata {
          tags
          source
          source_id
          source_name
          source_type
          source_url
        }
      }
    }
  }
`;

export const SEARCH_TRAINING_MEMORIES = gql`
  query SearchTrainingMemories($data: SearchTrainingMemoriesInputType!) {
    search_training_memories(data: $data) {
      hasError
      message
      data {
        _id
        agent_id
        content {
          text
          media {
            type
            url
            metadata {
              _id
              name
              mimetype
              size
              description
              agent_id
              owner_id
            }
          }
        }
        created_at
        updated_at
        metadata {
          tags
          source
          source_id
          source_name
          source_type
          source_url
        }
        score
      }
    }
  }
`;

export interface CreateMemoryEntriesInput {
  agent_id: string;
  entries: {
    _id: string;
    content: MemoryEntryContent;
    metadata: MemoryMetadata;
    isDeleted?: boolean;
  }[];
}

export interface SearchTrainingMemoriesInput {
  agent_id: string;
  searchTerm: string;
  limit?: number;
  tags?: string[];
  source_type?: string;
}
